import React from "react";
import AWS from "aws-sdk";
import { Container, Row, Col } from "react-bootstrap";
import { FaArrowCircleUp } from "react-icons/fa";

export interface S3UploaderProps {
  image: string;
  imageName: string;
  bucketName: string;
  folderName: string;
  s3ClientName: string;
  onUploadSuccess?: (url: string) => void;
  onUploadError?: (error: Error) => void;
}

const COGNITO_IDENTITY_POOL_ID = process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID; 

// Validate and set AWS region (addresses aws-sdk v2 security advisory)
const AWS_REGION = "ap-southeast-2";
if (!/^[a-z0-9-]+$/.test(AWS_REGION)) {
  throw new Error("Invalid AWS region format");
}
AWS.config.region = AWS_REGION; 

const S3Uploader: React.FC<S3UploaderProps> = ({
  image,
  imageName,
  bucketName,
  folderName,
  s3ClientName,
  onUploadSuccess,
  onUploadError,
}) => {
  const base64ToBlob = (base64: string) => {
    const byteString = atob(base64.split(",")[1]);
    const mimeString = base64.split(",")[0].split(":")[1].split(";")[0];
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const intArray = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      intArray[i] = byteString.charCodeAt(i);
    }
    return new Blob([arrayBuffer], { type: mimeString });
  };

  const uploadImage = async () => {
    if (!COGNITO_IDENTITY_POOL_ID) {
      throw new Error("Missing Cognito Identity Pool ID in environment variables");
    }
    AWS.config.credentials = new AWS.CognitoIdentityCredentials({
      IdentityPoolId: COGNITO_IDENTITY_POOL_ID,
    });
    
    // Ensure the credentials are refreshed before upload
    (AWS.config.credentials as AWS.CognitoIdentityCredentials).get(async function (err) {
      if (err) {
        console.error("Error getting Cognito credentials:", err);
        if (onUploadError) onUploadError(err);
        return;
      }

      const s3 = new AWS.S3();

      const keyName = `${s3ClientName}/${folderName}/${imageName}`;
      const binaryImage = base64ToBlob(image);

      const params = {
        Bucket: bucketName,
        Key: keyName,
        Body: binaryImage,
        ContentType: "image/jpeg",
        ACL: "public-read",
      };

      try {
        const response = await s3.upload(params).promise();
        console.log("Upload successful:", response.Location);
        if (onUploadSuccess) {
          onUploadSuccess(response.Location);
        }
      } catch (uploadErr) {
        console.error("Upload failed:", uploadErr);
        if (onUploadError) {
          onUploadError(uploadErr as Error);
        }
      }
    });
  };

  React.useEffect(() => {
    uploadImage();
  }, []);

  return (
    <Container className="text-center">
      <Row>
        <Col>
        </Col>
      </Row>
    </Container>
  );
};

export default S3Uploader;
